module.exports = __webpack_public_path__ + "img/lego-5.22be2812.jpg";